import { thickness, length, width, certification } from '@/modules/standardItems/schemas/baseFilters'

export function moistureResistant () {
  return {
    label: 'Moisture Resistant',
    value: 'moistureResistant',
    type: 'checkbox'
  }
}

export function fireRated () {
  return {
    label: 'Fire Rated',
    value: 'fireRated',
    type: 'checkbox'
  }
}

export function sheetStockFilters () {
  return [
    certification(),
    thickness(),
    length(),
    width()
  ]
}

export default sheetStockFilters
